import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { prefetchOtcHall } from '../hooks/prefetchOtcHall';

export function BottomTabs() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const warmTradingHall = () => prefetchOtcHall(qc);

  const TABS = [
    { to: '/wallet', label: t('tabs.wallet'), icon: '/brand/bottom-tabs/wallet.png', activeIcon: '/brand/bottom-tabs/wallet-a.png' },
    { to: '/trading', end: false, label: t('tabs.trading'), icon: '/brand/bottom-tabs/uo-trading.png', activeIcon: '/brand/bottom-tabs/uo-trading-a.png' },
    { to: '/ep-hub', label: t('tabs.ep'), icon: '/brand/bottom-tabs/ep-trading.png', activeIcon: '/brand/bottom-tabs/ep-trading-a.png' },
    { to: '/me', label: t('tabs.me'), icon: '/brand/bottom-tabs/me.png', activeIcon: '/brand/bottom-tabs/me-a.png' },
  ];

  return (
    <nav className="z-50 h-[75px] shrink-0 rounded-t-[11px] border-t border-[#E2B833] bg-[#0C1214] shadow-[inset_0_4px_13.3px_0_rgba(245,236,99,0.25)] safe-bottom">
      <div className="flex h-full items-stretch justify-around">
        {TABS.map(({ to, label, icon, activeIcon, end }, index) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            onMouseEnter={to === '/trading' ? warmTradingHall : undefined}
            onTouchStart={to === '/trading' ? warmTradingHall : undefined}
            className={({ isActive }) =>
              clsx(
                'relative flex flex-1 flex-col items-center justify-center gap-0.5 pb-[9px] pt-2 text-[11px] font-semibold leading-none tracking-[0.55px] text-white transition-opacity',
                isActive ? 'opacity-100' : 'opacity-90',
              )
            }
          >
            {({ isActive }) => (
              <>
                <img
                  src={isActive ? activeIcon : icon}
                  alt=""
                  width={39}
                  height={39}
                  loading="eager"
                  decoding="async"
                  className={clsx(
                    'size-[39px] object-contain transition-opacity'
                  )}
                  draggable={false}
                />
                <span className="whitespace-nowrap mb-1">{label}</span>
                {isActive && (
                  <span className="absolute bottom-[8px] h-px w-[24px]" style={{ background: "linear-gradient(90deg, #ADD741 0%, #347E23 47.6%, #ADD741 100%)" }} />
                )}
                {index < TABS.length - 1 && (
                  <span className="pointer-events-none absolute right-0 top-[17px] h-9 w-px bg-gradient-to-b from-transparent via-[#ADD741] to-transparent" />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
